module.exports = __webpack_public_path__ + "img/full0-min.4a7700f1.png";